import { render, staticRenderFns } from "./AccessData.vue?vue&type=template&id=39da99fa&scoped=true&"
import script from "./AccessData.vue?vue&type=script&lang=js&"
export * from "./AccessData.vue?vue&type=script&lang=js&"
import style0 from "./AccessData.vue?vue&type=style&index=0&id=39da99fa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da99fa",
  null
  
)

export default component.exports